import { Component, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { NotyService } from '@app/services';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  standalone: false
})
export class BadgeComponent implements OnInit {
  badgeSizes = ['badge-L', 'badge-M', 'badge-S', 'badge-XS'];
  badgeVariants = ['badge-neutral', 'badge-success', 'badge-warning', 'badge-error', 'badge-premium', 'badge-primary', 'badge-pending'];

  constructor(private clipboardService: ClipboardService, private notyService: NotyService) {}

  ngOnInit() {}

  copyToClipboard(size: string, variant: string) {
    const spanToCopy = `<span class="monster__badge ${size} ${variant}">Label</span>`;
    this.clipboardService.copyFromContent(spanToCopy);
    this.notyService.success('Badge copiado', 500);
  }
}
